<script setup>
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import AvailablePageRow from "@/components/kit-settings/partials/AvailablePageRow.vue";
import SearchInput from "@/components/global-themed/SearchInput.vue";
import TabHeading from "@/components/kit-settings/partials/TabHeading.vue";
import {availablePages, useKitPages} from "@/composables/kit-settings/useKitPages";
import {computed, ref} from "vue";

const {getAvailablePages} = useKitPages();
const {isPending} = getAvailablePages();

const search = ref('');

const filteredPages = computed(() => {
  if (search.value === '') {
    return availablePages.value;
  }

  return availablePages.value.filter((page) => page.page_url?.includes(search.value));
})
</script>

<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-8 tw-border tw-border-neutral-300 tw-rounded-xl tw-bg-white tw-relative tw-p-8 tw-flex-1 tw-min-h-0 tw-overflow-hidden">
    <div class="tw-flex tw-flex-col tw-gap-4">
      <div class="tw-flex tw-justify-between tw-items-center">
        <TabHeading
          class="tw-h-12"
          icon="icons/calendar-outline"
          heading="Available Pages"
        />

        <SearchInput
          v-model="search"
          placeholder="Search Pages"
        />
      </div>

      <div class="tw-text-neutral-500">
        Below are all the pages I can work on next. This list is automatically ordered for you based on what needs attention. Click the star icon next to any page to add it to your priority list.
      </div>
    </div>

    <div
      v-if="filteredPages?.length > 0 && !isPending"
      class="tw-flex tw-flex-col tw-gap-4 tw-overflow-auto tw-flex-1 tw-min-h-0"
    >
      <AvailablePageRow
        v-for="(page, index) in filteredPages"
        :key="index"
        :page="page"
      />
    </div>

    <LoadingBlock v-else-if="isPending" />
    <ZeroContent v-else>
      No available pages
    </ZeroContent>
  </div>
</template>
